import React from "react";

import type { DwhExport } from "@/api/warehouse_ops";
import { dwhDiffTitle, dwhLineView, dwhSideText } from "@/lib/warehouse-ops";
import { cn } from "@/lib/utils";

const TONE: Record<ReturnType<typeof dwhLineView>["tone"], string> = {
  neutral: "border bg-white text-muted-foreground",
  ok: "border bg-white text-muted-foreground",
  diff: "border-amber-300 bg-amber-50 text-amber-900",
  error: "border-rose-300 bg-rose-50 text-rose-800",
};

/** Сверка «передано в DWH / сейчас по порталу» (`mart.wh_ops_daily` + `wh_ops_state`).
 *  Передачи ещё не было — серой строкой «ещё не передавалось» (не ошибка и не 0);
 *  расходится — янтарём, со статьями под спойлером: DWH против портала. */
export function DwhExportLine({
  dwh,
  periodFrom,
  periodTo,
}: {
  dwh: DwhExport;
  periodFrom: string;
  periodTo: string;
}): React.ReactElement {
  const v = dwhLineView(dwh, periodFrom, periodTo);
  return (
    <section
      aria-label="Передано в DWH"
      className={cn("space-y-1 rounded-lg p-3 text-xs", TONE[v.tone])}
    >
      <div
        role={v.tone === "error" ? "alert" : undefined}
        className={cn(v.tone !== "neutral" && "font-medium")}
      >
        {v.text}
      </div>
      {v.notes.map((n) => (
        <div key={n}>{n}</div>
      ))}
      {dwh.diffs.length > 0 && (
        <details>
          <summary className="cursor-pointer select-none font-medium">
            Что расходится · {dwh.diffs.length}
          </summary>
          <div className="mt-1 overflow-x-auto">
            <table className="w-full text-left tabular-nums">
              <thead>
                <tr>
                  <th className="py-0.5 pr-3 font-medium">Статья</th>
                  <th className="py-0.5 pr-3 font-medium">В DWH</th>
                  <th className="py-0.5 font-medium">Сейчас по порталу</th>
                </tr>
              </thead>
              <tbody>
                {dwh.diffs.map((d) => (
                  <tr key={`${d.direction}/${d.operation}`}>
                    <th scope="row" className="py-0.5 pr-3 font-normal">
                      {dwhDiffTitle(d)}
                    </th>
                    <td className="py-0.5 pr-3">{dwhSideText(d.dwh_volume, d.dwh_amount, d.unit)}</td>
                    <td className="py-0.5">{dwhSideText(d.portal_volume, d.portal_amount, d.unit)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </details>
      )}
    </section>
  );
}
